<template lang="html">
    <div ref="deck"
         class="deck"
         v-resize:throttle="scaleCards">
        <div ref="cards"
             class="playingcards-wrapper"
             :style="{
                 transform: 'scale(' + scale + ')',
                 opacity: opacity,
             }">
            <div v-for="(card, i) in room.deck"
                 :key="i"
                 class="playingcard-rotate"
                 :style="{
                     transform: getRotate(i),
                     zIndex: card.properties.zindex,
                     display: card.revealed ? 'none' : 'block',
                 }">
                <div class="playingcard-translate"
                     :style="{
                         transform:
                             'translateY(' +
                             parseInt(180 + card.properties.translation) +
                             'px)',
                     }">
                    <a :id="card.identifier"
                       :ref="card.identifier"
                       href="#"
                       @click.prevent="pickCard"
                       class="playingcard"
                       :class="cardTheme">
                        <div class="inner">
                            <div class="front"></div>
                            <div class="back"></div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import resize from 'vue-resize-directive';

export default {
    data() {
        return {
            scale: 1,
            toastCounter: 0,
            opacity: 0.0001,
            picked: false,
            cardTheme: '',
        };
    },
    directives: {
        resize,
    },
    computed: {
        room() {
            return this.$store.state.room;
        },
        isUserTurn() {
            return (
                this.room.turn.player_id === this.$store.state.user.player_id
            );
        },
        active() {
            return this.room.latestCard;
        },
    },
    mounted() {
        this.getCardTheme();
        this.$bus.$on('clearCard', () =>
            $('.playingcard-rotate.active').fadeOut(),
        );
    },
    watch: {
        active(data) {
            var card = $(this.$refs[data.identifier]);
            card.addClass(`playingcard-${data.suit} playingcard-${data.value}`);
            card.parents('.playingcard-rotate').addClass('active');
        },
    },
    methods: {
        getCardTheme() {
            this.cardTheme = window.localStorage.getItem('card');
            return this.cardTheme;
        },
        // Resize the cards to fit the container
        scaleCards() {
            this.$refs.deck.style.width = this.$refs.deck.clientHeight + 'px';

            this.scale = Math.min(
                this.$refs.deck.clientHeight / this.$refs.cards.clientHeight,
                this.$refs.deck.clientWidth / this.$refs.cards.clientWidth,
            );
            if (this.opacity === 0.0001) this.opacity = 1;
        },

        // Get card rotation value
        getRotate(i) {
            var rotateValue = (360 / this.room.deck.length) * i;
            rotateValue = rotateValue > 180 ? -360 + rotateValue : rotateValue;
            return 'rotate(' + rotateValue + 'deg)';
        },

        // Pick the card
        pickCard(e) {
            if (this.isUserTurn && !this.$store.state.room.hasPicked) {
                this.$emit('cardPicked', e.target.id);
                this.picked = true;
            } else {
                this.toast(
                    'b-toaster-top-right',
                    true,
                    this.isUserTurn
                        ? 'Please end your turn'
                        : "It's not your turn",
                );
            }
        },

        toast(toaster, append = false, message) {
            this.toastCounter++;
            this.$bvToast.toast(message, {
                toaster: toaster,
                solid: true,
                appendToast: append,
                noCloseButton: true,
                toastClass: 'custom-toast-dark',
            });
        },
    },
};
</script>

<style lang="css"></style>
